import {getValueByActiveTab, toastifySeverityMap} from "../utils"

const CONSTANTS_POINTER_MAP = Object.freeze({
    bis: "/constants/bis"
})

const isEndYearValidForAge = (bis, getDataFromPointer) => bis > new Date(
    getValueByActiveTab(getDataFromPointer, "geburtsdatum")
).getFullYear() + Number.parseInt(getDataFromPointer(CONSTANTS_POINTER_MAP.bis))

const buildErrorPointer = (pointer, index) => `/messages/error${pointer?.replace("[i]", index)}`

export const validations = [
    {
        validator: ({bis, zeitraumArt, gebDatumKunde, gebDatumPartner, activeTab}, getDataFromPointer) =>
            zeitraumArt === "ALTER"
                ? bis > Number.parseInt(getDataFromPointer(CONSTANTS_POINTER_MAP.bis))
                : isEndYearValidForAge(bis, getDataFromPointer),
        message: "Eine Betrachtung ist nur bis 100 Jahre möglich.",
        severity: toastifySeverityMap.WARN,
        errorPointer: buildErrorPointer("/appstate/zeitraum/bis")
    },
    // Wird entfernt sobald Validierung im Backend umgesetzt ist
    {
        arrayKey: "kinder",
        validator: ({kindergeldBisAlter}, _) =>
            Number.parseInt(kindergeldBisAlter) < 18 || Number.parseInt(kindergeldBisAlter) > 25,
        message: (index) => `Bitte geben Sie für das ${index + 1}. Kind das Alter, bis zu dem Kindergeld gezahlt wird, zwischen 18 und 25 Jahren an.`,
        severity: toastifySeverityMap.WARN,
        errorPointer: (index) => buildErrorPointer("/kinder/[i]/kindergeldBisAlter", index)
    },
]